export default __webpack_public_path__ + "static/media/portfolio.a25b42f6.webp";